(function () {
  'use strict';

  var SELECTOR_ROOT = '[data-featured-bundle]';
  var SELECTOR_STICKY_HEADER = '#shopify-section-header';
  var PANEL_SCROLL_GAP = 16;

  function formatMoney(cents, moneyFormat, currency) {
    var value = (Number(cents) || 0) / 100;

    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, moneyFormat || (window.theme && theme.moneyFormat) || '${{amount}}');
    }

    try {
      return value.toLocaleString(undefined, {
        style: 'currency',
        currency: currency || 'USD'
      });
    } catch (e) {
      return '$' + value.toFixed(2);
    }
  }

  function FeaturedBundle(root) {
    if (!root || root.dataset.initialized === 'true') return;

    this.root = root;
    this.moneyFormat = root.dataset.moneyFormat || '';
    this.currency = root.dataset.currency || 'USD';
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onClick = this.onClick.bind(this);

    root.dataset.initialized = 'true';
    root.addEventListener('click', this.onClick);
    document.addEventListener('keydown', this.onKeyDown);
    root.querySelectorAll('[data-products-panel]').forEach(this.updatePanelState.bind(this));
  }

  FeaturedBundle.prototype.destroy = function () {
    this.root.removeEventListener('click', this.onClick);
    document.removeEventListener('keydown', this.onKeyDown);
    delete this.root.dataset.initialized;
  };

  FeaturedBundle.prototype.formatMoney = function (cents) {
    return formatMoney(cents, this.moneyFormat, this.currency);
  };

  FeaturedBundle.prototype.openPanel = function (blockId) {
    var root = this.root;

    root.querySelectorAll('[data-banner]').forEach(function (banner) {
      var active = banner.dataset.blockId === blockId;
      banner.classList.toggle('is-active', active);
      var trigger = banner.querySelector('[data-banner-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', active ? 'true' : 'false');
    });

    var openedPanel = null;

    root.querySelectorAll('[data-products-panel]').forEach(function (panel) {
      var open = panel.dataset.blockId === blockId;
      panel.classList.toggle('is-open', open);
      if (open) {
        panel.removeAttribute('hidden');
        openedPanel = panel;
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    if (openedPanel) this.scrollToPanel(openedPanel);
  };

  /* The theme header is sticky with a negative `top`, so only part of it stays
     pinned over the page. Measure that band rather than assuming a height —
     it varies with the merchant's logo. Returns 0 when the header isn't sticky. */
  FeaturedBundle.prototype.getPinnedHeaderHeight = function () {
    var header = document.querySelector(SELECTOR_STICKY_HEADER);
    if (!header) return 0;

    var styles = window.getComputedStyle(header);
    if (styles.position !== 'sticky' && styles.position !== 'fixed') return 0;

    var top = parseFloat(styles.top);
    if (isNaN(top)) top = 0;

    return Math.max(0, header.getBoundingClientRect().height + Math.min(0, top));
  };

  FeaturedBundle.prototype.scrollToPanel = function (panel) {
    var self = this;
    var prefersReducedMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    requestAnimationFrame(function () {
      panel.style.scrollMarginTop = self.getPinnedHeaderHeight() + PANEL_SCROLL_GAP + 'px';
      panel.scrollIntoView({
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
        block: 'start'
      });
    });
  };

  FeaturedBundle.prototype.getSelectedCards = function (panel) {
    return Array.prototype.slice.call(panel.querySelectorAll('[data-product-card].is-selected'));
  };

  FeaturedBundle.prototype.createSidebarItem = function (card) {
    var item = document.createElement('div');
    item.className = 'featured-bundle__sidebar-item';
    item.dataset.sidebarItem = '';
    item.dataset.variantId = card.dataset.variantId;

    var media = document.createElement('div');
    media.className = 'featured-bundle__sidebar-item-media';

    if (card.dataset.variantImage) {
      var img = document.createElement('img');
      img.src = card.dataset.variantImage;
      img.alt = card.dataset.variantTitle || '';
      img.loading = 'lazy';
      media.appendChild(img);
    }

    var title = document.createElement('p');
    title.className = 'featured-bundle__sidebar-item-title';
    title.textContent = card.dataset.variantTitle || '';

    var price = document.createElement('p');
    price.className = 'featured-bundle__sidebar-item-price';
    price.textContent = card.dataset.variantPriceFormatted || this.formatMoney(card.dataset.variantPrice);

    var remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'featured-bundle__sidebar-item-remove';
    remove.dataset.removeItem = '';
    remove.setAttribute('aria-label', 'Remove ' + (card.dataset.variantTitle || 'item'));
    remove.textContent = '\u00d7';

    item.appendChild(media);
    item.appendChild(title);
    item.appendChild(price);
    item.appendChild(remove);
    return item;
  };

  FeaturedBundle.prototype.syncSidebar = function (panel) {
    var tray = panel.querySelector('[data-sidebar-tray]');
    var empty = panel.querySelector('[data-sidebar-empty]');
    if (!tray) return;

    var selected = this.getSelectedCards(panel);
    tray.querySelectorAll('[data-sidebar-item]').forEach(function (item) {
      item.remove();
    });

    var self = this;
    selected.forEach(function (card) {
      tray.appendChild(self.createSidebarItem(card));
    });

    if (empty) {
      empty.hidden = selected.length > 0;
    }
  };

  FeaturedBundle.prototype.updatePanelState = function (panel) {
    var minCount = parseInt(panel.dataset.minCount, 10) || 1;
    var selected = this.getSelectedCards(panel);
    var total = selected.reduce(function (sum, card) {
      return sum + (parseInt(card.dataset.variantPrice, 10) || 0);
    }, 0);

    this.syncSidebar(panel);

    var enabled = selected.length >= minCount;
    var totalFormatted = this.formatMoney(total);

    panel.querySelectorAll('[data-add-to-cart]').forEach(function (atc) {
      var priceEl = atc.querySelector('[data-atc-price]');
      if (priceEl) priceEl.textContent = totalFormatted;
      atc.disabled = !enabled;
      atc.setAttribute('aria-disabled', enabled ? 'false' : 'true');
    });

    var countEl = panel.querySelector('[data-sticky-count]');
    if (countEl) {
      countEl.textContent =
        selected.length + (selected.length === 1 ? ' item' : ' items') + ' selected';
    }

    var stickyBar = panel.querySelector('[data-sticky-bar]');
    if (stickyBar) {
      stickyBar.classList.toggle('is-visible', enabled);
      stickyBar.setAttribute('aria-hidden', enabled ? 'false' : 'true');
    }
  };

  FeaturedBundle.prototype.setCardSelected = function (card, selected) {
    if (card.dataset.available === 'false') return;
    card.classList.toggle('is-selected', selected);
    var addBtn = card.querySelector('[data-add-btn]');
    if (addBtn && !addBtn.disabled) {
      addBtn.textContent = selected ? 'Added' : 'Add';
    }
  };

  FeaturedBundle.prototype.toggleCard = function (card) {
    if (card.dataset.available === 'false') return;
    this.setCardSelected(card, !card.classList.contains('is-selected'));
    this.updatePanelState(card.closest('[data-products-panel]'));
  };

  FeaturedBundle.prototype.openModal = function (template) {
    var modal = this.root.querySelector('[data-modal]');
    var content = this.root.querySelector('[data-modal-content]');
    if (!modal || !content || !template) return;

    content.innerHTML = '';
    content.appendChild(template.content.cloneNode(true));
    modal.classList.add('is-open');
    modal.removeAttribute('hidden');
    document.body.classList.add('featured-bundle-modal-open');
  };

  FeaturedBundle.prototype.closeModal = function () {
    var modal = this.root.querySelector('[data-modal]');
    var content = this.root.querySelector('[data-modal-content]');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('hidden', '');
    if (content) content.innerHTML = '';
    document.body.classList.remove('featured-bundle-modal-open');
  };

  FeaturedBundle.prototype.addToCart = async function (panel) {
    var minCount = parseInt(panel.dataset.minCount, 10) || 1;
    var buttons = Array.prototype.slice.call(panel.querySelectorAll('[data-add-to-cart]'));
    var selected = this.getSelectedCards(panel);
    if (buttons.length === 0 || selected.length < minCount) return;

    var busy = buttons.some(function (btn) {
      return btn.classList.contains('is-loading');
    });
    if (busy) return;

    var items = selected.map(function (card) {
      return { id: parseInt(card.dataset.variantId, 10), quantity: 1 };
    });

    buttons.forEach(function (btn) {
      btn.classList.add('is-loading');
      btn.disabled = true;
    });

    try {
      var routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var response = await fetch(routesRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });

      if (!response.ok) {
        throw new Error('Add to cart failed');
      }

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'featured-bundle' } }));
      document.dispatchEvent(new CustomEvent('rebuy:cart.add', { detail: { source: 'featured-bundle' } }));

      if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
        window.Rebuy.SmartCart.show();
      }
    } catch (error) {
      console.error('[FeaturedBundle]', error);
    } finally {
      buttons.forEach(function (btn) {
        btn.classList.remove('is-loading');
      });
      this.updatePanelState(panel);
    }
  };

  FeaturedBundle.prototype.onClick = function (event) {
    var root = this.root;
    var bannerTrigger = event.target.closest('[data-banner-trigger]');

    if (bannerTrigger && root.contains(bannerTrigger)) {
      var banner = bannerTrigger.closest('[data-banner]');
      if (banner) this.openPanel(banner.dataset.blockId);
      return;
    }

    var removeBtn = event.target.closest('[data-remove-item]');
    if (removeBtn && root.contains(removeBtn)) {
      var panel = removeBtn.closest('[data-products-panel]');
      var item = removeBtn.closest('[data-sidebar-item]');
      if (panel && item) {
        var card = panel.querySelector(
          '[data-product-card][data-variant-id="' + item.dataset.variantId + '"]'
        );
        if (card) this.setCardSelected(card, false);
        this.updatePanelState(panel);
      }
      return;
    }

    var addBtn = event.target.closest('[data-add-btn]');
    if (addBtn && root.contains(addBtn)) {
      var addCard = addBtn.closest('[data-product-card]');
      if (addCard) this.toggleCard(addCard);
      return;
    }

    var detailsBtn = event.target.closest('[data-details-trigger]');
    if (detailsBtn && root.contains(detailsBtn)) {
      var detailsCard = detailsBtn.closest('[data-product-card]');
      var template = detailsCard && detailsCard.querySelector('[data-details-template]');
      if (template) this.openModal(template);
      return;
    }

    var atc = event.target.closest('[data-add-to-cart]');
    if (atc && root.contains(atc)) {
      var atcPanel = atc.closest('[data-products-panel]');
      if (atcPanel) this.addToCart(atcPanel);
      return;
    }

    if (event.target.closest('[data-modal-close]') && root.contains(event.target.closest('[data-modal]'))) {
      this.closeModal();
    }
  };

  FeaturedBundle.prototype.onKeyDown = function (event) {
    if (event.key === 'Escape') this.closeModal();
  };

  function initRoot(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root._featuredBundle = new FeaturedBundle(root);
  }

  function initAll() {
    document.querySelectorAll(SELECTOR_ROOT).forEach(initRoot);
  }

  function destroyInContainer(container) {
    if (!container) return;
    container.querySelectorAll(SELECTOR_ROOT).forEach(function (root) {
      if (root._featuredBundle && typeof root._featuredBundle.destroy === 'function') {
        root._featuredBundle.destroy();
        delete root._featuredBundle;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    destroyInContainer(event.target);
    if (event.target) {
      event.target.querySelectorAll(SELECTOR_ROOT).forEach(initRoot);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyInContainer(event.target);
  });
})();
